// components/subscription/ExpiryReengagementModal.tsx
// A lapsed member returning → the ONE paywall with warm "expired" framing ("Pick up where
// you left off" + "your progress is saved"). No separate amber/gift modal — one honest flow.

import React from 'react'
import PaywallSheet from '../payment/PaywallSheet'

interface Props {
    onClose: () => void
}

const ExpiryReengagementModal: React.FC<Props> = ({ onClose }) => (
    <PaywallSheet reason="expired" onClose={onClose} />
)

export default ExpiryReengagementModal
